import { createEnumMap } from 'Commons/helpers/utils/Formatter';
import enums from './enums';

const CRUD_METHODS = createEnumMap(enums.crud);
const DEFAULT_EXTERNAL_ROUTE = '/a/facility';
const DEFAULT_INTERNAL_ROUTE = '/i';

export { CRUD_METHODS, DEFAULT_EXTERNAL_ROUTE, DEFAULT_INTERNAL_ROUTE };
